export function isNativeRuntime(): boolean {
  try {
    const w = window as any;
    // Capacitor 5+: isNativePlatform()
    if (w?.Capacitor?.isNativePlatform?.()) return true;
    // Capacitor getPlatform() ≠ 'web'
    if (w?.Capacitor?.getPlatform && w.Capacitor.getPlatform() !== 'web') return true;
    // Origen de WKWebView
    if (typeof location !== 'undefined' && location.origin?.startsWith?.('capacitor://')) return true;
  } catch {}
  return false;
}

export const IS_NATIVE = isNativeRuntime();
export const IS_WEB = !IS_NATIVE;